import { render, staticRenderFns } from "./Saxenda.vue?vue&type=template&id=3a277885&scoped=true&"
import script from "./Saxenda.vue?vue&type=script&lang=js&"
export * from "./Saxenda.vue?vue&type=script&lang=js&"
import style0 from "./Saxenda.vue?vue&type=style&index=0&id=3a277885&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a277885",
  null
  
)

export default component.exports